import { Component, Inject, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ImageViewerConfig, CustomImageEvent } from 'angular-x-image-viewer';
import { ConnectionService } from "ng-connection-service";
import * as XLSX from "xlsx";
import { viewerType } from '../document-viewer/document-viewer.component';
type AOA = any[][];
import * as FileSaver from "file-saver";
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LandTitleRegisterDto } from '@cradua/data';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'cradua-documentoperations',
  templateUrl: './documentoperations.component.html',
  styleUrls: ['./documentoperations.component.css']
})
export class DocumentoperationsComponent implements OnInit {
  OriginatingModule = "General";
  OriginatedModuleSpecificId = "Gen"
  SubmitIsTriggerByparent = "Gen"
  // @Input() doc: LandTitleRegisterDto;
  selectedDocument: any;
  showList = true;
  showDoc = false;
  docType = "";
  fileName = "SheetJS.xlsx";
  data: any;
  headData: any; // excel row header
  images = [];
  testURL = "http://localhost:3333/api/epimsgates/document/e4e836f9bed12c1078adcc9aae9b7218d.docx";
  @ViewChild("fullScreen", { static: true }) divRef: any;
  status = "ONLINE";
  isConnected = true;
  fileExist = true;
  fileExistMsg = "";


  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService,
    public dialogRef: MatDialogRef<DocumentoperationsComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
    this.connectionService.monitor().subscribe((isConnected) => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = "ONLINE";
      } else {
        this.status = "OFFLINE";
      }
    });
   }

  ngOnInit() {
    this.showdocument(this.modalData.doc);
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   console.log('changes', changes.doc.currentValue);
  //   if(changes.doc.currentValue) {
  //     this.showdocument(this.modalData.doc);
  //   }

  // }
  onNoClick(): void {
    this.dialogRef.close();
  }


  openFullscreen() {
    // Use this.divRef.nativeElement here to request fullscreen
    const elem = this.divRef.nativeElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    }
  }

  // tslint:disable-next-line: member-ordering
  viewers: {
    name: viewerType;
    docs: string[];
    custom: boolean;
    acceptedUploadTypes: string;
  }[] = [
    {
      name: "google",
      docs: [
        "https://file-examples.com/wp-content/uploads/2017/02/file-sample_100kB.docx",
        "https://file-examples.com/wp-content/uploads/2017/02/file_example_XLSX_10.xlsx",
        "https://file-examples.com/wp-content/uploads/2017/10/file_example_TIFF_1MB.tiff",
        "https://file-examples.com/wp-content/uploads/2017/10/file-sample_150kB.pdf",
        "https://file-examples.com/wp-content/uploads/2017/08/file_example_PPT_250kB.ppt",
      ],
      custom: true,
      acceptedUploadTypes: null,
    },
    {
      name: "office",
      docs: [
        "https://file-examples.com/wp-content/uploads/2017/02/file-sample_100kB.docx",
        "https://file-examples.com/wp-content/uploads/2017/02/file_example_XLSX_10.xlsx",
        "https://file-examples.com/wp-content/uploads/2017/10/file_example_TIFF_1MB.tiff",
        "https://file-examples.com/wp-content/uploads/2017/10/file-sample_150kB.pdf",
        "https://file-examples.com/wp-content/uploads/2017/08/file_example_PPT_250kB.ppt",
      ],
      custom: true,
      acceptedUploadTypes: null,
    },
    {
      name: "mammoth",
      docs: [`${window.location.href}/assets/file-sample_100kB.docx`],
      custom: false,
      acceptedUploadTypes:
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    },
    {
      name: "pdf",
      docs: [`${window.location.href}/assets/file-sample_150kB.pdf`],
      custom: false,
      acceptedUploadTypes: "application/pdf",
    },
  ];
  selectedViewer = this.viewers[0];
  selectedDoc = this.selectedViewer.docs[0];


  selectViewer(viewerName: viewerType) {
    if (viewerName !== this.selectViewer.name) {
      this.selectedViewer = this.viewers.find((v) => v.name === viewerName);
      this.selectedDoc = this.selectedViewer.docs[0];
    }
  }

  getDocExtension(doc: string) {
    const splittedDoc = doc.split(".");
    return splittedDoc[splittedDoc.length - 1];
  }

  handleFiles(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.selectedDoc = e.target.result;
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  imageIndexOne = 0;

  // tslint:disable-next-line: member-ordering
  config: ImageViewerConfig = {
    customBtns: [
      { name: "print", icon: "fa fa-print" },
      { name: "link", icon: "fa fa-link" },
    ],
  };

  handleEvent(event: CustomImageEvent) {
    // console.log(`${event.name} has been click on img ${event.imageIndex + 1}`);

    switch (event.name) {
      case "print":
        // console.log("run print logic");
        break;
    }
  }

  showdocument(doc: LandTitleRegisterDto) {
    this.selectedDocument = doc;

    if (doc.FileType.includes("image")) {
      this.docType = "Image";
      // this.images = [];
      this.images.push(doc.FilePath);

    }

    if (doc.FileType.includes("application/pdf")) {
      // console.log('doc', doc.FilePath);
      this.docType = "pdf";
    }

    if (doc.FileType.includes("video/mp4")) {
      // console.log('doc', doc.FilePath);
      this.docType = "video";
    }
    if (
      doc.FileType.includes(
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      )
    ) {
      this.docType = "mammoth";
    }

    if (
      doc.FileType.includes(
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      )
    ) {
      this.data = [];
      this.headData = [];

      this.docType = "Excel";

      this.http
        .get(doc.FilePath, {
          responseType: "blob",
        })
        .subscribe((response) => {
          const reader: FileReader = new FileReader();
          // const binaryString = reader.readAsDataURL(base64ImageUrl);
          reader.readAsBinaryString(response);

          // console.log('string data ', binaryString);
          reader.onload = (e: any) => {
            /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

            /* grab first sheet */
            const wsname: string = wb.SheetNames[0];
            const ws: XLSX.WorkSheet = wb.Sheets[wsname];

            /* save data */
            this.data = <AOA> (
              XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: 0 })
            );
            // console.log(this.data[1]);

            this.headData = this.data[0];

            // console.log("Head Data ", this.data);
            this.data = this.data.slice(1); // remove first header record

            const ws2: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[1]];
            this.readDataSheet(ws2, 10);
          };

          //doc.FileUploadPath
          //reader.readAsBinaryString(blob);

          //  this.downLoadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
        });
    }
    this.showDoc = true;
    this.showList = false;

    // this.documentForm.patchValue(doc);
  }

  gobackToDocList() {
    this.showDoc = false;
    this.showList = true;
    this.dialogRef.close();
  }

  downloadSelectedDoc() {
    // const pdfUrl = './assets/sample.pdf';
    // const pdfName = 'your_pdf_file';
    FileSaver.saveAs(
      this.selectedDocument.FilePath,
      this.selectedDocument.FileName.split(".")[0],
    );
  }

  downloadDoc(doc: any) {
    // const pdfUrl = './assets/sample.pdf';
    // const pdfName = 'your_pdf_file';
    FileSaver.saveAs(doc.FilePath, doc.FileName.split(".")[0]);
  }

  doesFileExist(urlToFile) {
    var xhr = new XMLHttpRequest();
    xhr.open("HEAD", urlToFile, false);
    xhr.send();

    if (xhr.status === 404) {
      return false;
    } else {
      return true;
    }
  }

  doesFileExistwithURL() {
    // let urlMain = this.documentForm.value.DocumentURL;
    let urlMain = '';
    if (urlMain.length === 0) {
      return;
    }
    var result = this.doesFileExist(urlMain);

    if (result == true) {
      // yay, file exists!

      // console.log("Valid path");

      this.fileExist = true;
    } else {
      // file does not exist!
      // console.log("InValid path");
      this.fileExist = false;
      this.fileExistMsg =
        "The Url supplied couldn't resolve to a file as a result of no internet connectivity or the url does not exist, please cross check or ignore to continue";
    }
  }


  private readDataSheet(ws: XLSX.WorkSheet, startRow: number) {
    /* save data */
    let datas = <AOA> (
      XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: startRow })
    );
    // console.log(datas[1]);
    let headDatas = datas[0];
    datas = datas.slice(1); // remove first header record

    for (let i = 0; i < this.data.length; i++) {
      this.data[i][this.headData.length] = datas.filter(
        (x) => x[12] == this.data[i][0],
      );
    }
    // console.log(this.data[1]);
  }

  export(): void {
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }

  convertBlobToBase64(blob: Blob) {
    return Observable.create((observer) => {
      const reader = new FileReader();
      const binaryString = reader.readAsDataURL(blob);

      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: "binary" });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        this.data = <AOA> (
          XLSX.utils.sheet_to_json(ws, { header: 1, raw: false, range: 0 })
        );
        // console.log(this.data[1]);

        this.headData = this.data[0];

        // console.log("Head Data ", this.data);
        this.data = this.data.slice(1); // remove first header record

        const ws2: XLSX.WorkSheet = wb.Sheets[wb.SheetNames[1]];
        this.readDataSheet(ws2, 10);
      };

      //doc.FileUploadPath
      reader.readAsBinaryString(blob);
      // reader.onload = (event: any) => {
      //   console.log('Image in Base64: ', event.target.result);
      //   observer.next(event.target.result);
      //   observer.complete();
      // };

      reader.onerror = (event: any) => {
        // console.log("File could not be read: " + event.target.error.code);
        observer.next(event.target.error.code);
        observer.complete();
      };
    });
  }

  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == "undefined") {
      alert("Please disable your Pop-up blocker and try again.");
    }
  }



}
